import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1, // Replace with an appropriate hiking image
        title: 'Guided Hikes',
        content: 'Explore scenic trails and breathtaking landscapes with our experienced guides leading the way.',
        paragraphs: [
            'Join our guided hikes to discover nature’s wonders while learning about local flora, fauna, and natural history from seasoned experts.',
            'Each hike is designed to match various fitness levels and interests, offering safe and enjoyable experiences for all participants.'
        ],
        gallery: [
            images.service1Gallery1, // Replace with guided hike photos
            images.service1Gallery2
        ],
        features: [
            'Expert-led hikes across diverse terrains',
            'Customized routes for all skill levels',
            'Educational insights into local ecosystems',
            'Safety-focused planning and execution',
            'Small group experiences for a personal touch'
        ],
        process: [
            'Choose your preferred trail or hiking event',
            'Get a pre-hike briefing and checklist',
            'Embark on the hike with a professional guide',
            'Engage in educational and interactive stops',
            'Conclude with a group recap and feedback session'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What should I bring on a guided hike?',
                content: 'We recommend comfortable hiking shoes, water, weather-appropriate clothing, and any personal essentials. A checklist is provided before the hike.'
            },
            {
                id: 2,
                heading: 'Are the hikes beginner-friendly?',
                content: 'Yes, we offer routes suitable for all experience levels, including beginner-friendly options with gentle terrain and slower pace.'
            },
            {
                id: 3,
                heading: 'Is transportation provided?',
                content: 'Transportation may be available for select events. Please refer to the specific hike details or contact us for more information.'
            },
            {
                id: 4,
                heading: 'What happens in case of bad weather?',
                content: 'In the event of severe weather, hikes may be rescheduled or refunded. Light rain won’t stop us—we’re always prepared!'
            }
        ]
    },
    {
        id: 2,
        image: images.service2, // Replace with a suitable camping image
        title: 'Camping Excursions',
        content: 'Unwind under the stars and reconnect with nature on our fully organized camping adventures.',
        paragraphs: [
            'Our camping excursions are designed for outdoor enthusiasts who seek comfort, safety, and an immersive experience in the wild.',
            'From scenic campgrounds to remote wilderness sites, enjoy nights around the fire, group activities, and the tranquility of nature.'
        ],
        gallery: [
            images.service2Gallery1, // Replace with images of tents, campfires, nature
            images.service2Gallery2
        ],
        features: [
            'Well-planned multi-day camping trips',
            'High-quality gear and equipment provided',
            'Campfire meals and outdoor cooking sessions',
            'Nature activities, games, and group bonding',
            'Guided support from setup to wrap-up'
        ],
        process: [
            'Select your preferred excursion package',
            'Receive gear checklist and safety brief',
            'Travel to campsite with our guides',
            'Enjoy camping, meals, and nature activities',
            'Pack down and return with lifelong memories'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do I need to bring my own camping gear?',
                content: 'No, we provide tents, sleeping bags, and basic camping equipment. You’re welcome to bring personal items if you prefer.'
            },
            {
                id: 2,
                heading: 'Are the campsites family-friendly?',
                content: 'Yes, many of our excursions are perfect for families, with fun and educational activities suitable for all ages.'
            },
            {
                id: 3,
                heading: 'Is food included during the trip?',
                content: 'Yes, we offer delicious campfire meals and snacks prepared with care. Special dietary needs can be accommodated with prior notice.'
            },
            {
                id: 4,
                heading: 'What safety measures are in place?',
                content: 'Our guides are first-aid certified and equipped with emergency gear. Safety protocols are followed throughout the trip.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3, // Replace with a relevant wilderness survival image
        title: 'Wilderness Survival',
        content: 'Master essential survival skills and build confidence to thrive in the wild with our expert-led training programs.',
        paragraphs: [
            'Our wilderness survival experience is ideal for adventurers seeking to learn real-world survival tactics in a safe, controlled environment.',
            'From building shelters to sourcing food and water, this immersive training prepares you for unexpected challenges in the great outdoors.'
        ],
        gallery: [
            images.service3Gallery1, // Replace with photos of fire starting, shelters, foraging
            images.service3Gallery2
        ],
        features: [
            'Hands-on survival training in real environments',
            'Fire making, shelter building, and foraging lessons',
            'Water purification and emergency first aid techniques',
            'Navigation without GPS or digital tools',
            'Expert guides with field-tested experience'
        ],
        process: [
            'Choose a training level: beginner to advanced',
            'Attend a pre-trip safety and prep session',
            'Learn survival techniques on a guided trek',
            'Practice skills in controlled scenarios',
            'Complete survival challenges and receive feedback'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Is prior outdoor experience required?',
                content: 'Not at all. We offer beginner-friendly programs as well as advanced survival challenges for seasoned adventurers.'
            },
            {
                id: 2,
                heading: 'What kind of skills will I learn?',
                content: 'You’ll learn fire building, shelter construction, water sourcing, plant identification, emergency signaling, and more.'
            },
            {
                id: 3,
                heading: 'Is the training safe?',
                content: 'Absolutely. All sessions are conducted under expert supervision with a strong emphasis on safety and participant comfort.'
            },
            {
                id: 4,
                heading: 'What should I bring for the course?',
                content: 'We’ll provide a checklist prior to the session, but essentials like sturdy footwear, outdoor clothing, and personal items are needed.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4, // Replace with a suitable group hiking/camping image
        title: 'Group Expeditions',
        content: 'Embark on thrilling group adventures designed to connect people through shared outdoor experiences.',
        paragraphs: [
            'Our group expeditions are perfect for teams, families, and friends looking to explore the wilderness together while enjoying well-planned and guided outdoor journeys.',
            'Experience camaraderie, adventure, and the joy of conquering trails side by side with like-minded explorers.'
        ],
        gallery: [
            images.service4Gallery1, // Replace with group trekking or camping moments
            images.service4Gallery2
        ],
        features: [
            'Fully guided multi-day trips',
            'Ideal for families, teams, and friends',
            'Custom itineraries and group-friendly pacing',
            'Campfire bonding and team-building activities',
            'All logistics handled by our experienced staff'
        ],
        process: [
            'Select an expedition based on location and duration',
            'Gather your group and complete registration',
            'Attend a pre-trip briefing and gear check',
            'Set off on a guided journey with full support',
            'Enjoy shared adventures, meals, and memories'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How large can our group be?',
                content: 'Group sizes typically range from 6 to 20 people, but we can accommodate larger teams with custom planning.'
            },
            {
                id: 2,
                heading: 'Are group expeditions suitable for beginners?',
                content: 'Yes! We tailor routes and activities to match the group’s overall skill and comfort level.'
            },
            {
                id: 3,
                heading: 'Can we customize the itinerary?',
                content: 'Absolutely. We offer custom group expedition packages based on your preferences, duration, and group size.'
            },
            {
                id: 4,
                heading: 'What’s included in the package?',
                content: 'We provide guides, meals, camping gear (optional), permits, and a well-structured itinerary for a seamless experience.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5, // Replace with a relevant equipment rental image
        title: 'Equipment Rental',
        content: 'High-quality gear rentals to ensure your outdoor adventure is safe, comfortable, and fully equipped.',
        paragraphs: [
            'Don’t have your own hiking or camping gear? No worries! We offer a wide range of premium outdoor equipment available for rent at affordable prices.',
            'From tents and backpacks to trekking poles and cooking kits, we’ve got everything you need for a smooth journey into the wild.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Top-notch camping and hiking gear',
            'Flexible daily or weekly rental options',
            'Pre-trip gear checks and instructions',
            'Cleaned and maintained equipment',
            'Affordable rates and gear bundles'
        ],
        process: [
            'Browse available gear and select what you need',
            'Choose rental duration and reserve online',
            'Pick up gear or opt for delivery (if available)',
            'Receive usage instructions and safety tips',
            'Return gear after your adventure—easy and hassle-free'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What kind of equipment do you rent?',
                content: 'We rent tents, sleeping bags, hiking backpacks, cooking kits, lanterns, trekking poles, and more.'
            },
            {
                id: 2,
                heading: 'Do I need to clean the equipment before returning it?',
                content: 'We clean and sanitize all equipment after each use, but we do ask that you return items in reasonably clean condition.'
            },
            {
                id: 3,
                heading: 'Is there a deposit required?',
                content: 'Yes, a refundable deposit is required for certain high-value items. Details will be provided during checkout.'
            },
            {
                id: 4,
                heading: 'Can I rent gear for a multi-day trip?',
                content: 'Absolutely! We offer flexible rental periods to suit day hikes, weekend getaways, or extended expeditions.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6, // Replace with an appropriate image for Adventure Tours
        title: 'Adventure Tours',
        content: 'Thrilling guided tours crafted for adrenaline seekers and nature lovers alike.',
        paragraphs: [
            'Embark on unforgettable journeys through rugged terrains, scenic mountain paths, and remote wilderness trails with our professionally guided adventure tours.',
            'Perfect for those craving exploration and excitement, our tours are designed to push your limits while connecting you with nature like never before.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Expert-led exploration tours',
            'Hand-picked scenic and challenging trails',
            'Custom itineraries for all fitness levels',
            'Safety-focused planning and guidance',
            'Small group sizes for a personal experience'
        ],
        process: [
            'Select your preferred tour destination and date',
            'Book online and receive your adventure pack',
            'Meet your tour guide at the starting point',
            'Embark on a thrilling journey through nature',
            'Wrap up with group reflections and memorable moments'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Are the tours suitable for beginners?',
                content: 'Yes! We offer tours for all experience levels, from beginner to advanced. Each tour includes difficulty ratings and recommended fitness levels.'
            },
            {
                id: 2,
                heading: 'What should I pack for an adventure tour?',
                content: 'We’ll provide a detailed checklist based on your selected tour, but essentials include hiking boots, a backpack, water bottle, and weather-appropriate clothing.'
            },
            {
                id: 3,
                heading: 'Are meals included in the tour?',
                content: 'Some tours include meal packages, while others allow you to bring your own. Full details are provided during the booking process.'
            },
            {
                id: 4,
                heading: 'Is transportation provided to the trailhead?',
                content: 'Transportation options vary by tour. Some include pickup/drop-off, while others require you to meet at the designated start point.'
            }
        ]
    }

];

export default services;